import React, { useEffect, useState } from "react";
import styles from "./Footer.module.css";
import { Link } from "react-router-dom";

const Footer = () => {
  const [isRevealed, setIsRevealed] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY + window.innerHeight; // Current scroll position + viewport height
      const documentHeight = document.documentElement.scrollHeight; // Total height of the document

      // Reveal footer when scrolled to the bottom 20% of the page
      if (scrollPosition >= documentHeight * 0.98) {
        setIsRevealed(true);
      } else {
        setIsRevealed(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <footer
      className={`${styles.footer} ${isRevealed ? styles.revealed : styles.hidden}`}
    >
      <div className={styles.container}>
        {/* Logo Section */}
        <div className={styles.logoContainer}>
          <div className={styles.logo}> <img 
           src={`https://studiomaamangala.com/wp-content/uploads/2025/02/mmstudio.svg`}
           alt="logo SVG"
           width={60} // Bigger Image
           height={50}
          /></div>
        </div>

        {/* Links Section */}
        <div className={styles.linksContainer}>
          <Link to="/about" className={styles.link}>
            About
          </Link>
          <Link to="/services" className={styles.link}>
            Services
          </Link>
          <Link to="/contact" className={styles.link}>
            Contact
          </Link>
        </div>
      </div>

      {/* Bottom Text */}
      <div className={styles.bottomText}>
        &copy; {new Date().getFullYear()} Studio MaaMangala. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
